import CaseMonitorProceduresContainer from './CaseMonitorProceduresContainer';

export default CaseMonitorProceduresContainer;
